import * as React from 'react'
import { Button } from './button'
import type { ButtonProps } from './button'

interface EmptyStateProps {
	illustration?: React.ReactNode
	title: string
	description?: string
	action?: {
		label: string
		onClick?: () => void
		variant?: ButtonProps['variant']
	}
	/**
	 * Custom action slot — rendered instead of the simple `action` button
	 * when provided. Use this when the call-to-action needs to be a dropdown,
	 * a group of buttons, or any composed element.
	 */
	actionSlot?: React.ReactNode
}

function EmptyState({ illustration, title, description, action, actionSlot }: EmptyStateProps) {
	return (
		<div className="flex size-full flex-col items-center justify-center pb-12 px-3">
			<div className="flex flex-col items-center gap-6">
				{illustration}
				<div className="flex flex-col items-center gap-1 text-center">
					<p className="text-2xl font-medium leading-8 tracking-[-0.6px] text-foreground">
						{title}
					</p>
					{description && (
						<p className="text-sm leading-5 text-muted-foreground">
							{description}
						</p>
					)}
				</div>
				{actionSlot ?? (action && (
					<Button variant={action.variant} onClick={action.onClick}>
						{action.label}
					</Button>
				))}
			</div>
		</div>
	)
}

export { EmptyState }
export type { EmptyStateProps }
